<template>
    <div class="nav_top">
        <div class="hamburger">
            <img :src="logo_small" alt="电子回单">
        </div>
        <el-menu class = "nav_top_bar" :default-active="$route.path" mode="horizontal" text-color="#333" active-text-color="#eb662b" @select="handleSelect">
            <el-menu-item :index="'/homepage'" >首页</el-menu-item>
            <el-menu-item @click="external('/homepage',1)" >货物跟踪</el-menu-item>
            <el-submenu v-for="(item,index) in Main" :key="index" :index="item.redirect">
                <template slot="title">{{item.meta.title}}</template>
                <el-menu-item v-for="element in item.children" :key="element.path" :index="element.path" @click="external(element.path)">{{element.meta.title}}</el-menu-item>
            </el-submenu>
            <el-menu-item @click="external('/aboutUsUs?activeIndex=2')">企业咨询</el-menu-item>
            <el-menu-item @click="external('/homepage')">了解物流源</el-menu-item>
        </el-menu>
        <div class="button_login"><span class="iconfont icon-dianhua hotlineImg"></span>&nbsp&nbsp4008-539-529</div>
        <!-- <div class="nav_top_operating">
            <el-dropdown style="float:right;" trigger="click" @command="roleHandle">
                <span class="el-dropdown-link">
                    {{userName}}
                    <i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="Center">个人中心</el-dropdown-item>
                    <el-dropdown-item command="Login">退出</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div> -->
    </div>
</template>

<script>
export default {
  // inject:['reload'],
  name: "nav-top-bar",
  data() {
    return {
      logo_small: '../../static/logo_new.png',
      userName: sessionStorage.userName,
      Main: [
        {
          path: 'scheme', redirect: '/Visual',   name: 'scheme', meta: { title: '数字化方案' ,icon: 'el-icon-location'},
          children: [
            { path: '/Visual', name: 'scheme-Visual', hidden: false, meta: { title: '可视化解决方案' } },
            { path: '/Paperless', name: 'scheme-Paperless', hidden: false, meta: { title: '无纸化解决方案' } },
            { path: '/Management', name: 'scheme-Management', hidden: false, meta: { title: '智能物流管理解决方案' } },
            { path: '/Digitization', name: 'scheme-Digitization', hidden: false, meta: { title: '数字化运营解决方案' } }
          ]
        }
      ]
    };
  },
  created(){
    console.log(this.$route.path)
  },
  methods: {
    roleHandle(val) {
      this.$router.push({ name: val });
    },
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
      this.$router.push({ path: keyPath[0] });
    },
    external (url,type) {
      if (type == 1) {
        window.open(this.$store.state.urls + '/#' + url, '_self');
      } else {
        window.open(this.$store.state.url + '/#' + url, '_self');
      }
    }
  },
  components:{
  }
};
</script>



// WEBPACK FOOTER //
// src/components/NavTopBar.vue